export { default, type IconTextSectionProps } from './IconTextSection';
